import { render, staticRenderFns } from "./HistoricPaysheets.vue?vue&type=template&id=e22aa132&"
import script from "./HistoricPaysheets.vue?vue&type=script&lang=js&"
export * from "./HistoricPaysheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports